export enum EEstadoReserva {
  PENDIENTE = 'PENDIENTE',
  CONFIRMADA = 'CONFIRMADA',
  CANCELADA = 'CANCELADA',
  COMPLETADA = 'COMPLETADA',
}

export enum EDiaSemana {
  LUNES = 0,
  MARTES = 1,
  MIERCOLES = 2,
  JUEVES = 3,
  VIERNES = 4,
  SABADO = 5,
  DOMINGO = 6,
}

export const DIAS_SEMANA_LABELS: Record<number, string> = {
  [EDiaSemana.LUNES]: 'Lunes',
  [EDiaSemana.MARTES]: 'Martes',
  [EDiaSemana.MIERCOLES]: 'Miércoles',
  [EDiaSemana.JUEVES]: 'Jueves',
  [EDiaSemana.VIERNES]: 'Viernes',
  [EDiaSemana.SABADO]: 'Sábado',
  [EDiaSemana.DOMINGO]: 'Domingo',
};
